const styles = () => ({
  container: {
    padding: '20px',
  },
  slotsTitle: {
    paddingTop: '15px',
  },
  slotsValue: {
    fontWeight: 600,
  },
});

export default styles;
